import * as React from "react";

function SvgRecombeeAi(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="1em"
      height="1em"
      viewBox="0 10 50 44"
      {...{ ...props, ref }}
    >
      <defs>
        <path id="RecombeeAI_svg__a" d="M0 0h50.276v35.982H0z" />
        <path
          id="RecombeeAI_svg__c"
          d="M10.774 41.835a10.75 10.75 0 01-8.503-4.158l-.16-.21A10.72 10.72 0 010 31.062V10.774C0 4.819 4.827 0 10.782 0l.288.004c5.823.152 10.495 4.915 10.495 10.77l-.001 9.496h9.498c5.858 0 10.617 4.674 10.77 10.496l.003.287c0 5.956-4.823 10.782-10.773 10.782z"
        />
      </defs>
      <g fill="none" fillRule="evenodd" transform="translate(0 14)">
        <mask id="RecombeeAI_svg__b" fill="#fff">
          <use xlinkHref="#RecombeeAI_svg__a" />
        </mask>
        <g mask="url(#RecombeeAI_svg__b)">
          <g transform="rotate(135 22.156 23.907)">
            <mask id="RecombeeAI_svg__d" fill="#fff">
              <use xlinkHref="#RecombeeAI_svg__c" />
            </mask>
            <use
              fill="#0FA5A5"
              fillOpacity={0}
              xlinkHref="#RecombeeAI_svg__c"
            />
            <path
              fill="#FFC021"
              mask="url(#RecombeeAI_svg__d)"
              d="M10.782 31.053l10.783-10.782h20.27v21.564H10.782z"
            />
            <path
              fill="#0FA5A5"
              mask="url(#RecombeeAI_svg__d)"
              d="M-.504-1.002L22.472.358l-.907 19.913-10.228 10.412H0z"
            />
            <path
              fill="#3BC4A1"
              d="M21.564 20.27v10.792c0 5.954-4.827 10.773-10.782 10.773l-.287-.004A10.776 10.776 0 010 31.053l.004-.287c.152-5.824 4.915-10.495 10.77-10.495h10.79z"
              mask="url(#RecombeeAI_svg__d)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgRecombeeAi);
